import styled from 'styled-components';
import { SIZE } from '../../const';

export const StyledButton = styled.button`
    width: 63px;
    height: 27px;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    background: #EEEEEE;
    color: #7D7D7D;
    text-align: center;
    border: none;
    border-radius: 5px;
    cursor: pointer;
`;

export const StyledButtonOrange = styled(StyledButton)`
    white-space: nowrap;
    padding: 0;
    background: #F58517;
    color: #FFFFFF;
`

export const StyledButtonOrangeBig = styled(StyledButtonOrange)`
    border-radius: 51px;
    width: 240px;
    height: 40px;
    font-weight: bold;
    font-size: 14px;

    @media ${SIZE.tablet} {
        height: 33px;
    }
`;